<app-guest-auth-main-layout>
 <ng-template>
   <div class=" p-10 flex flex-col items-center  ">
     <div class="bg-gradient-to-t from-gray-100 to-white mt-4 p-3 text-center rounded-md !text-gray-800">
      {{"Kama Nywila imesahaulika, tafadhali omba nywila mpya kwa kupitia nambari ya simu ama anuani yako" |concat|translate }}
     </div>

     <div class="mt-3 w-full">
       <div class="grid w-full grid-cols-2 gap-2">
         <div (click)="changeView('phoneNumber')"
              [ngClass]="{'bg-primary-500 text-secondary-500 hover:bg-primary-600': viewType === 'phoneNumber', 'bg-gray-50 text-gray-700 hover:bg-gray-200': viewType !== 'phoneNumber'}"
              class="p-3 cursor-pointer rounded-md">{{"Tumia Namba ya Simu" |concat|translate }}
         </div>
         <div (click)="changeView('emailAddress')"
              [ngClass]="{'bg-primary-500 text-secondary-500 hover:bg-primary-600': viewType === 'emailAddress', 'bg-gray-50 text-gray-700 hover:bg-gray-200': viewType !== 'emailAddress'}"
              class="p-3 cursor-pointer rounded-md">{{"Tumia Barua Pepe" |concat|translate }}
         </div>
       </div>
     </div>

     <div class="mt-3 w-full">
       <!-- Phone Number Form -->
       <div *ngIf="viewType === 'phoneNumber'">
         <form [formGroup]="form" (ngSubmit)="onSubmit()">
           <mat-form-field appearance="outline" class="w-full intro-x mt-2">
             <mat-label>{{"Namba ya Simu" |concat|translate }}</mat-label>
             <span class="ml-2" matPrefix>+255&nbsp;</span>
             <input [showMaskTyped]="true" class="w-full" mask="000000000" matInput formControlName="phoneNumber"
                    type="text" placeholder="{{'Ingiza namba ya simu' |concat|translate }}"/>
             <mat-error *ngIf="phoneNumber?.hasError('required')">{{"Namba ya simu ni lazima" |concat|translate }}</mat-error>
           </mat-form-field>
           <button mat-raised-button class="!bg-primary-500 !text-white  w-full" type="submit" [disabled]="form.invalid">
             {{"Omba Nywila Mpya" |concat|translate }}
           </button>
         </form>
       </div>

       <!-- Email Address Form -->
       <div *ngIf="viewType === 'emailAddress'">
         <form [formGroup]="form" (ngSubmit)="onSubmit()">
           <mat-form-field appearance="outline" class="w-full intro-x  mt-2">
             <mat-label>{{"Barua Pepe" |concat|translate }}</mat-label>
             <input matInput formControlName="emailAddress" type="email" placeholder="{{'Ingiza barua pepe' |concat|translate }}"/>
             <mat-error *ngIf="emailAddress?.hasError('required')">{{"Barua pepe ni lazima" |concat|translate }}</mat-error>
             <mat-error *ngIf="emailAddress?.hasError('email')">{{"Ingiza barua pepe sahihi" |concat|translate }}</mat-error>
           </mat-form-field>

           <button mat-raised-button class="!bg-primary-500  !text-white w-full" type="submit" [disabled]="form.invalid">
             {{"Omba Nywila Mpya" |concat|translate }}
           </button>
         </form>
       </div>

       <div class="p-3 w-full text-center">
         <a class="text-primary-500 text-decoration-none hover:!font-bold" routerLink="/login">
           {{"Kurasa ya Kuingia Kwenye Mfumo" |concat|translate }}
         </a>
       </div>
     </div>
   </div>

 </ng-template>

</app-guest-auth-main-layout>
